import React from "react";
import { Link } from "react-router-dom";
import { Icon, Container } from "semantic-ui-react";

export const Footer = () => {
    return (<Container style={{ marginBottom: '1em', marginTop: '1em' }}>
        <span style={{ float: 'left' }}><Icon name='copyright outline' /> {new Date().getFullYear()} - Finnigan's Harp Nürnberg e.V.</span>
        <span style={{ float: 'right' }}><Link to='/impress'>Impressum</Link></span>
    </Container>)
}